// validator-interface.js
export class ValidatorInterface {
    // Returns Zod schema refinement
    // eslint-disable-next-line no-unused-vars
    getZodSchema(baseSchema, options = {}) {
        throw new Error("Method not implemented");
    }

    // For async validators that can't use Zod schema
    // eslint-disable-next-line no-unused-vars
    async validateExternal(value, options = {}) {
        return true; // Default implementation for non-async validators
    }

    // Returns error message
    // eslint-disable-next-line no-unused-vars
    getErrorMessage(field, options = {}) {
        throw new Error("Method not implemented");
    }
}
